/**
 * Create playing icon
 *
 * @param {string} className
 */
export default function CreatePlayingIcon(className = "", textAfter = "") {
  return `<span class="live-player-icon ${className}">Live</span>${textAfter}`;
}
